import { render, staticRenderFns } from "./Classifier.vue?vue&type=template&id=4c429e4e&scoped=true&"
import script from "./Classifier.vue?vue&type=script&lang=js&"
export * from "./Classifier.vue?vue&type=script&lang=js&"
import style0 from "./Classifier.vue?vue&type=style&index=0&id=4c429e4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c429e4e",
  null
  
)

export default component.exports